<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :news="news" />
			<LayoutDetail :news="news" />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutDetail from "./components/LayoutDetail.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";

export default {
	mixins: [Meta],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutDetail,
		BaseLoading
	},

	data() {
		return {
			news: [],
			pageActive: false,
			loading: true
		};
	},

	created() {
		this.axios.get("/json/news_detail.json").then(response => {
			this.news = response.data.news;
			this.loading = false;
			this.pageActive = true;
		});
	}
};
</script>

<style lang="scss">
</style>